import mutations from "./mutations"
import actions from './actions'

export default {
    namespaced: true,
    mutations,
    state: {},
    actions
}
